module.exports = __webpack_public_path__ + "static/img/erweima_yufa.b0e484b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima/erweima_yufa.png
// module id = Ut+R
// module chunks = 124